import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output
} from '@angular/core';
import { FundListingBRConfiguration, FundListingDataFormat, SortingItems } from "@products/types";
import { CommonService } from '@services/common.service';
import { TranslateService } from "@shared/translate/translate.service";

@Component({
  selector: 'ft-empty-page',
  templateUrl: './empty-page.component.html',
  styleUrls: ['./empty-page.component.scss']
})
export class EmptyPageComponent implements OnInit, OnChanges {

  @Input() isAddFund = false
  @Input() fundData: any;
  @Input() addFundData: boolean;
  @Input() sideFilterOptions: any;
  @Input() CartSectionImg: boolean = false
  @Input() makeCartToggle: boolean = true
  @Input() comaredCardImg: boolean = false
  @Input() pageSubHeading: string = ""
  @Input() cardTypeData: any;
  @Input() isMobileAdd: boolean;
  @Input() fundCompareIds: any;
  @Output() fund: EventEmitter<any> = new EventEmitter<any>();
  @Output() addToCartOutputInEmptyPage: EventEmitter<any> = new EventEmitter();
  fundListingData: FundListingDataFormat[] | FundListingDataFormat[];
  @Input() hasThreeDotOptions!: boolean;
  @Input() brConfiguration: FundListingBRConfiguration;

  funds: any = []
  selectedFund: any = null;
  isLoaded: boolean;
  badgeValue: string;
  filterName: string;
  focusFunds: any = [];
  sortItemsArray: SortingItems[] = [];
  selectedSortItem: SortingItems;

  searchTerm: string = '';
  fullFundsArray: FundListingDataFormat[] = [];
  fundsForSearch: FundListingDataFormat[] = [];
  activeButton: string = 'All';

  showFundSearchDropdown: boolean = true;


  @HostListener('click', ['$event'])
  getTableDataPage(event: Event) {
    const clickedElement = event.target as Element;
    if (clickedElement.classList.contains('funds-seach-title')) {
      this.showFundSearchDropdown = false;
    } else if (clickedElement.classList.contains('form-control')) {
      this.showFundSearchDropdown = true;
    } else if (!clickedElement.classList.contains('funds-seach-title')) {
      this.showFundSearchDropdown = false;
    }
  }

  constructor(
    private translateService: TranslateService,
    private cdr: ChangeDetectorRef,
    private commonService: CommonService,
  ) {
  }

  ngOnInit(): void {
    this.setEmptyFundData();
    try {
      this.sortItemsArray = JSON.parse(this.translateService.instant("products.funds-sorting-list"));
    } catch (error) {
      console.log("Error in parsing Json", error);
    }
    if (this.sortItemsArray && this.sortItemsArray.length > 0) {
      this.selectedSortItem = this.sortItemsArray?.find(item => item.default) || this.sortItemsArray[0];
    }

  }

  ngOnChanges() {
    this.commonService.send_added_fund.subscribe((getFund) => {
      if (getFund) {
        this.setEmptyFundData();
        this.customizeFundData()
      }
    });
    document.getElementById("All")?.click();
  }

  setEmptyFundData() {
    this.badgeValue = this.translateService.instant("products.focused-funds-badge");
    let focusFunds = this.translateService.instant("products.focused-funds-config");
    this.filterName = this.translateService.instant("products.focused-funds-filter-name");
    const focusFundsArray = focusFunds.split(",");
    this.focusFunds = focusFundsArray.map(number => {
      return {"fundId": number};
    });
    if (this.fundData) {
      this.customizeFundData();
      this.isLoaded = true;
    }
  }

  customizeFundData() {
    let modifiedData = this.fundData;
    // Sort the array based on averageAnnualReturnSinceInception
    modifiedData.sort((a, b) => {
      const returnA = parseFloat(a?.shareClassData?.performanceData?.averageAnnualReturnSinceInception);
      const returnB = parseFloat(b?.shareClassData?.performanceData?.averageAnnualReturnSinceInception);

      // Check if the parsed values are valid numbers
      const isValidNumberA = !isNaN(returnA);
      const isValidNumberB = !isNaN(returnB);

      // Handle cases where either or both values are not valid numbers
      if (isValidNumberA && isValidNumberB) {
        // Sort based on valid numeric values
        return returnB - returnA;
      } else if (isValidNumberA && !isValidNumberB) {
        // Sort valid numbers before non-valid numbers
        return -1;
      } else if (!isValidNumberA && isValidNumberB) {
        // Sort valid numbers before non-valid numbers
        return 1;
      } else {
        // Maintain the current order if neither value is a valid number
        return 0;
      }
    });
    for (let i = 0; i < modifiedData.length; i++) {
      let selectedFund = modifiedData[i];

      // Find the object with value "averageAnnualReturnSinceInception" in ppssPeriodDropdownItems
      let selectedDropdown = selectedFund.ppssPeriodDropdownItems.find(item => item.value === "averageAnnualReturnSinceInception");

      // Add selectedDropdown to the main object
      selectedFund.selectedDropdown = selectedDropdown;
    }
    // Adding the Focus Badge.
    this.fundListingData = modifiedData.map(fund => {
      // Check if the fundId is in focusFunds array
      if (this.focusFunds.some(focusFund => focusFund.fundId === fund.fundId)) {
        // Add the badge property
        return {...fund, badge: this.badgeValue ? this.badgeValue : 'focus', addBtnStatus: true};
      }
      return fund;
    });

    // Sort the array based on badge and prioritize funds with badge: focus
    this.fundListingData.sort((a, b) => {
      // Check if funds have the badge: focus property
      const aHasFocusBadge = a.badge === "focus";
      const bHasFocusBadge = b.badge === "focus";

      // Prioritize funds with the badge: focus property
      if (aHasFocusBadge && !bHasFocusBadge) {
        return -1;
      } else if (!aHasFocusBadge && bHasFocusBadge) {
        return 1;
      }

      // If both funds have the badge: focus property or neither does,
      // maintain the current order in the array
      return 0;
    });
    this.fullFundsArray = this.fundListingData;
  }

  showContentOnHover(event: any) {
    this.clearSearchWithSelectedSort(); // Retaining the Seleted Sorting even after chaning the Tabs.
    if (event.target.id) {
      this.fundListingData = [];
      this.customizeFundData();
      if (event.target.id !== 'All') {
        this.fundListingData = this.fundListingData.filter(fund => fund.assetClass === event.target.id);
      }
      if (this.selectedSortItem?.id !== 'popular') {
        this.sortFunds(this.selectedSortItem); // Retaining the Seleted Sorting even after chaning the Tabs.
      }

      this.cdr.detectChanges();
    }
  }

  getMenuID(menuName?: any, vpills?: boolean): string {
    if (!vpills) {
      let menuID = menuName.replace(/\s+/g, '-') + '-button';
      return menuID.toLowerCase();
    } else {
      let menuID = menuName.replace(/\s+/g, '-');
      return menuID.toLowerCase();
    }
  }

  clearSearch() {
    this.fundListingData = this.fullFundsArray;
    this.fundsForSearch = this.fundListingData;
    this.searchTerm = '';
    this.setActiveButton('All'); // After Clearing the Search Selected Tab will be All
    this.sortFunds({ // After Clearing the Search Selected Tab with default Sorting.
      "id": "popular",
      "label": "Popularity - High to Low",
      "mobileLabel": "High to Low",
      "mobileTitle": "Popularity",
      "default": true
    })
  }

  clearSearchWithSelectedSort() {
    this.fundListingData = this.fullFundsArray;
    this.fundsForSearch = this.fundListingData;
    this.searchTerm = '';
  }

  sortFunds(item: SortingItems): void {
    this.selectedSortItem = item;

    // Sort the fundListingData based on the selected criteria
    switch (item.id) {
      case 'popular':
        this.customizeFundData();
        break;

      case 'returnsHtoL':
        this.fundListingData = this.sortDataByAverageAnnualReturn(this.fundListingData);
        break;

      case 'fundSizeHtoL':
        this.fundListingData.sort((a, b) => {
          const sizeA = a.aum && a.aum.totalNetAssets ? parseFloat(a.aum.totalNetAssets) : -Infinity;
          const sizeB = b.aum && b.aum.totalNetAssets ? parseFloat(b.aum.totalNetAssets) : -Infinity;

          // Move funds with empty aum to the end
          if (!a.aum || Object.keys(a.aum).length === 0) {
            return 1; // Move a to the end
          }

          if (!b.aum || Object.keys(b.aum).length === 0) {
            return -1; // Move b to the end
          }

          return sizeB - sizeA;
        });
        break;

      case 'investorsHtoL':
        this.fundListingData.sort((a, b) => {
          const investorsA = parseInt(a.uniqueInvestors.replace(',', ''));
          const investorsB = parseInt(b.uniqueInvestors.replace(',', ''));
          return investorsB - investorsA;
        });
        break;

      // Add more cases for other sorting criteria if needed

      default:
        break;
    }
  }

  sortDataByAverageAnnualReturn(data: any[]): any[] {
    return data.sort((a, b) => {
      const returnA = parseFloat(a?.shareClassData?.performanceData?.averageAnnualReturnSinceInception);
      const returnB = parseFloat(b?.shareClassData?.performanceData?.averageAnnualReturnSinceInception);

      // Check if the parsed values are valid numbers
      const isValidNumberA = !isNaN(returnA);
      const isValidNumberB = !isNaN(returnB);

      // Handle cases where either or both values are not valid numbers
      if (isValidNumberA && isValidNumberB) {
        // Sort based on valid numeric values
        return returnB - returnA;
      } else if (isValidNumberA && !isValidNumberB) {
        // Sort valid numbers before non-valid numbers
        return -1;
      } else if (!isValidNumberA && isValidNumberB) {
        // Sort valid numbers before non-valid numbers
        return 1;
      } else {
        // Maintain the current order if neither value is a valid number
        return 0;
      }
    });
  }

  searchFunds(searchTerm: string) {
    if (searchTerm && searchTerm.length >= 3) {
      this.fundsForSearch = this.fullFundsArray;
      this.fundsForSearch = this.fundsForSearch.filter((fund: any) =>
        fund.fundName.toLowerCase().includes(searchTerm.toLowerCase())
      );
    } else {
      this.fundsForSearch = this.fullFundsArray;
    }
  }

  showSelectedFund(fund: any) {
    this.showFundSearchDropdown = false;
    this.setActiveButton(fund?.assetClass);
    this.selectedFund = fund;
    this.searchTerm = this.selectedFund?.fundName;
    const fundsArray = [...this.fullFundsArray];
    const selectedFund = fundsArray.find(fund => fund.fundId === this.selectedFund.fundId);
    this.fundListingData = [selectedFund];
  }


  setActiveButton(buttonName: string): void {
    this.activeButton = buttonName;
  }

  removeFundString(value: string) {
    value = value.replace(/funds|fund/gi, "");
    return value;
  }
}
